import React from 'react';
import AutenticacaoConsumer from '../../providers/autenticacao/AutenticacaoConsumer';
import { Link } from 'react-router-dom'

function UnauthorizedPage() {
    return (<AutenticacaoConsumer>
        {({ unauthorized }) => {
            return (
                <>
                    <div align="center" style={{ width: '70%', margin: '2em auto' }}>
                        <h2>Ooops :(</h2>
                        <span>Você não tem permissão para utilizar este aplicativo.</span>
                        <br /><br />
                        <Link to="/signout">Trocar usuário</Link>
                    </div>

                </>
            );
        }}
    </AutenticacaoConsumer>);
}

export default UnauthorizedPage;